import type React from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import styled from "styled-components"
import { Login, Logout } from "~/modules/authentication"
import { LoginConfirm } from "~/modules/authentication/LoginConfirm"
import { LoginWithPassword } from "~/modules/authentication/LoginWithPassword"
import { Register } from "~/modules/authentication/Register"
import { ResetPassword } from "~/modules/authentication/ResetPassword"
import { VerifyEmail } from "~/modules/authentication/VerifyEmail"
import { Authenticate } from "~/modules/main/Authenticate"
import ConfirmResetPassword from "../authentication/ConfirmResetPassword"
import ExistingSchoolWaitingAcceptance from "../authentication/confirmationScreens/ExistingSchoolWaitingAcceptance"
import NewSchoolAwaitingConfirmation from "../authentication/confirmationScreens/NewSchooAwaitingConfirmation"
import FeideCallback from "../authentication/feide/FeideCallback"

import { PostHogProvider } from "posthog-js/react"

const postHogOptions = {
  api_host: import.meta.env.VITE_APP_PUBLIC_POSTHOG_HOST,
}

const Layout = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
`

export const Root: React.FC = () => {
  return (
    <Layout>
      <BrowserRouter>
        <PostHogProvider
          apiKey={import.meta.env.VITE_APP_PUBLIC_POSTHOG_KEY}
          options={postHogOptions}
        >
          <Routes>
            <Route path="login" element={<Login />} />
            <Route path="login-confirm" element={<LoginConfirm />} />
            <Route path="login-email" element={<LoginConfirm />} />
            <Route
              path={"login-with-password"}
              element={<LoginWithPassword />}
            />
            <Route path="register" element={<Register />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="verify-email" element={<VerifyEmail />} />
            <Route path="feide/callback" element={<FeideCallback />} />
            <Route
              path="confirm-reset-password"
              element={<ConfirmResetPassword />}
            />
            <Route path="logout" element={<Logout />} />
            <Route
              path="register/school/existing-school-wait-for-approval"
              element={<ExistingSchoolWaitingAcceptance />}
            />
            <Route
              path="register/school/new-school-wait-for-approval"
              element={<NewSchoolAwaitingConfirmation />}
            />
            
            <Route path="/*" element={<Authenticate />} />
          </Routes>
        </PostHogProvider>
      </BrowserRouter>
    </Layout>
  )
}
